export default __webpack_public_path__ + "static/MineralSwimV2_Web_Existing-Pool-60cc018d1173d63e82b3f3b16cd57dce.jpg";